export default __webpack_public_path__ + "static/media/crown_icon.0d7c4e3b.svg";